<template>
  <div id="myProfile">
    <div class="content_box">
      <div class="inner">
        <global-title :title="$t('menu.myProfile')"></global-title>
        <div class="main">
          <el-row :gutter="0" class="profile_special">
            <el-col :xs="24" :sm="8" :md="8" class="profile_col">
              <div class="profile_logo"><img src="@/assets/images/myProfile/header_logo.png" alt="" srcset="" /></div>
              <div>
                <span class="profile_title profile_name">{{ clientProfileData.name }}</span>
                <span class="profile_value">{{ accountType[clientProfileData.accountType] || '--' }}</span>
              </div>
            </el-col>
            <el-col :xs="24" :sm="8" :md="8">
              <span class="profile_title">{{ $t('common.field.emailAdd') }}</span>
              <span class="profile_value">{{ clientProfileData.emailAddress || '--' }}</span>
            </el-col>
            <el-col :xs="24" :sm="8" :md="8">
              <span class="profile_title">{{ $t('common.field.phone') }}</span>
              <span class="profile_value">{{ clientProfileData.phone || '--' }}</span>
            </el-col>
            <el-col :xs="24" :sm="8" :md="8">
              <span class="profile_title">UID</span>
              <span class="profile_value cursor-pointer" @click="onCopy"
                >{{ clientProfileData.userId || '--' }}
                <svg-icon
                  v-if="clientProfileData.userId"
                  iconName="copy-icon"
                  style="width: 12px; height: 12px"
                ></svg-icon>
              </span>
            </el-col>
          </el-row>
        </div>
        <div class="main info">
          <el-row :gutter="0">
            <el-col :xs="24" :sm="8" :md="8" :class="{ fr: this.bodyDirection === 'rtl' }">
              <span class="profile_title">{{ $t('common.field.dob') }}</span>
              <span class="profile_value">{{ clientProfileData.dateBirth || '--' }}</span>
            </el-col>
            <el-col :xs="24" :sm="8" :md="8">
              <span class="profile_title">{{ $t('common.field.nat') }}</span>
              <span class="profile_value">{{ clientProfileData.nationality || '--' }}</span>
            </el-col>
            <el-col :xs="24" :sm="8" :md="8">
              <span class="profile_title">{{ $t('common.field.country') }}</span>
              <span class="profile_value">{{ clientProfileData.country || '--' }}</span>
            </el-col>
            <el-col :xs="24" :sm="8" :md="8" :class="{ fr: this.bodyDirection === 'rtl' }">
              <span class="profile_title">{{ $t('common.field.address') }}</span>
              <span class="profile_value">{{ clientProfileData.streetAddress || '--' }}</span>
            </el-col>
            <el-col :xs="24" :sm="8" :md="8">
              <span class="profile_title">{{ $t('common.field.suburbOrCity') }}</span>
              <span class="profile_value">{{ clientProfileData.suburb || '--' }}</span>
            </el-col>
            <el-col :xs="24" :sm="8" :md="8">
              <span class="profile_title">{{ $t('common.field.empStat') }}</span>
              <span class="profile_value">{{ clientProfileData.employmentStatus || '--' }}</span>
            </el-col>
            <el-col :xs="24" :sm="8" :md="8" :class="{ fr: this.bodyDirection === 'rtl' }">
              <span class="profile_title">{{ $t('common.field.source') }}</span>
              <span>{{ clientProfileData.sourceOfFunds || '--' }}</span>
            </el-col>
            <el-col :xs="24" :sm="8" :md="8">
              <span class="profile_title">{{ $t('common.field.save') }}</span>
              <span class="profile_value">{{ clientProfileData.savingsInvestment || '--' }}</span>
            </el-col>
            <el-col :xs="24" :sm="8" :md="8">
              <span class="profile_title">{{ $t('common.field.annIncome') }}</span>
              <span class="profile_value">{{ clientProfileData.averageIncome || '--' }}</span>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :class="{ fr: this.bodyDirection === 'rtl' }">
              <span class="profile_title">{{ $t('common.field.occupation') }}</span>
              <span class="profile_value">{{ clientProfileData.occupation || '--' }}</span>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiInfo } from '@/resource';
import { apiSubmitResetChangeIpWarn } from '@/resource';
import GlobalTitle from '@/components/global/title';
export default {
  components: { GlobalTitle },
  data() {
    return {
      clientProfileData: {
        accountType: '',
        title: '',
        name: '',
        emailAddress: '',
        phone: '',
        userId: '',
        dateBirth: '',
        occupation: '',
        averageIncome: '',
        country: '',
        streetAddress: '',
        suburb: '',
        state: '',
        postcode: '',
        cardNumber: ''
      },
      accountType: Object.freeze({
        1: 'Demo Account',
        2: 'Personal Account',
        3: 'Master Joint Account',
        4: 'Vice Joint Account',
        5: 'IB Individual Account',
        6: 'Internal Account',
        7: 'Experience Account',
        8: 'Leads Account',
        9: 'Repetitive Leads Account',
        10: 'Imported Leads Account',
        11: 'Irregular Leads Account',
        13: 'Company Account',
        14: 'SMSF Account',
        15: 'Vice Leads Account',
        16: 'IB Company Account',
        17: 'Migration Leads Account',
        18: 'Migration Demo Account',
        19: 'Conflict Account'
      }),
      bodyDirection: null
    };
  },
  mounted() {
    apiInfo().then(resp => (this.clientProfileData = resp.data.data));

    this.$nextTick(() => {
      this.bodyDirection = document.body.dir;
    });
  },
  methods: {
    onCopy(e) {
      this.$message({
        message: this.$t('common.message.copied'),
        type: 'success'
      });
      navigator.clipboard.writeText(this.clientProfileData.userId);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/myProfile.scss';
</style>
